import german_flag from '../images/flag-german.jpg';
import usa_flag from '../images/flag-usa.png';
import PropTypes from 'prop-types';
import img_options from '../images/options.png';
import img_workers from '../images/workers.png';
import img_appointments from '../images/appointments.png';
import img_clients from '../images/clients.png';
import img_orders from '../images/orders.png';
import img_release from '../images/release.png';
import img_assistant from '../images/post-process.png';
import i18n from '../i18n';
import mapValues from "lodash/mapValues";
import values from "lodash/values";
import areIntlLocalesSupported from 'intl-locales-supported';
import moment from "./Moment";
import {IconAssignment, IconBuild, IconContacts, IconDashBoard, IconEvent, IconGroup, IconLockOpen} from "./icons";


let DateTimeFormat;

export const PRODUCTION_MODE = process.env.NODE_ENV === 'production';
// export const VERSION_PATH = process.env.REACT_APP_VERSION_PATH || '/devroot/autohaus-api/config/.version';
export const VERSION = window._VERSION = Number(process.env.REACT_APP_VERSION || process.env.VERSION) || -1;


const svgLoader = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 841.9 595.3">\n' +
	'    <g fill="#61DAFB">\n' +
	'        <path d="M666.3 296.5c0-32.5-40.7-63.3-103.1-82.4 14.4-63.6 8-114.2-20.2-130.4-6.5-3.8-14.1-5.6-22.4-5.6v22.3c4.6 0 8.3.9 11.4 2.6 13.6 7.8 19.5 37.5 14.9 75.7-1.1 9.4-2.9 19.3-5.1 29.4-19.6-4.8-41-8.5-63.5-10.9-13.5-18.5-27.5-35.3-41.6-50 32.6-30.3 63.2-46.9 84-46.9V78c-27.5 0-63.5 19.6-99.9 53.6-36.4-33.8-72.4-53.2-99.9-53.2v22.3c20.7 0 51.4 16.5 84 46.6-14 14.7-28 31.4-41.3 49.9-22.6 2.4-44 6.1-63.6 11-2.3-10-4-19.7-5.2-29-4.7-38.2 1.1-67.9 14.6-75.8 3-1.8 6.9-2.6 11.5-2.6V78.5c-8.4 0-16 1.8-22.6 5.6-28.1 16.2-34.4 66.7-19.9 130.1-62.2 19.2-102.7 49.9-102.7 82.3 0 32.5 40.7 63.3 103.1 82.4-14.4 63.6-8 114.2 20.2 130.4 6.5 3.8 14.1 5.6 22.5 5.6 27.5 0 63.5-19.6 99.9-53.6 36.4 33.8 72.4 53.2 99.9 53.2 8.4 0 16-1.8 22.6-5.6 28.1-16.2 34.4-66.7 19.9-130.1 62-19.1 102.5-49.9 102.5-82.3zm-130.2-66.7c-3.7 12.9-8.3 26.2-13.5 39.5-4.1-8-8.4-16-13.1-24-4.6-8-9.5-15.8-14.4-23.4 14.2 2.1 27.9 4.7 41 7.9zm-45.8 106.5c-7.8 13.5-15.8 26.3-24.1 38.2-14.9 1.3-30 2-45.2 2-15.1 0-30.2-.7-45-1.9-8.3-11.9-16.4-24.6-24.2-38-7.6-13.1-14.5-26.4-20.8-39.8 6.2-13.4 13.2-26.8 20.7-39.9 7.8-13.5 15.8-26.3 24.1-38.2 14.9-1.3 30-2 45.2-2 15.1 0 30.2.7 45 1.9 8.3 11.9 16.4 24.6 24.2 38 7.6 13.1 14.5 26.4 20.8 39.8-6.3 13.4-13.2 26.8-20.7 39.9zm32.3-13c5.4 13.4 10 26.8 13.8 39.8-13.1 3.2-26.9 5.9-41.2 8 4.9-7.7 9.8-15.6 14.4-23.7 4.6-8 8.9-16.1 13-24.1zM421.2 430c-9.3-9.6-18.6-20.3-27.8-32 9 .4 18.2.7 27.5.7 9.4 0 18.7-.2 27.8-.7-9 11.7-18.3 22.4-27.5 32zm-74.4-58.9c-14.2-2.1-27.9-4.7-41-7.9 3.7-12.9 8.3-26.2 13.5-39.5 4.1 8 8.4 16 13.1 24 4.7 8 9.5 15.8 14.4 23.4zM420.7 163c9.3 9.6 18.6 20.3 27.8 32-9-.4-18.2-.7-27.5-.7-9.4 0-18.7.2-27.8.7 9-11.7 18.3-22.4 27.5-32zm-74 58.9c-4.9 7.7-9.8 15.6-14.4 23.7-4.6 8-8.9 16-13 24-5.4-13.4-10-26.8-13.8-39.8 13.1-3.1 26.9-5.8 41.2-7.9zm-90.5 125.2c-35.4-15.1-58.3-34.9-58.3-50.6 0-15.7 22.9-35.6 58.3-50.6 8.6-3.7 18-7 27.7-10.1 5.7 19.6 13.2 40 22.5 60.9-9.2 20.8-16.6 41.1-22.2 60.6-9.9-3.1-19.3-6.5-28-10.2zM310 490c-13.6-7.8-19.5-37.5-14.9-75.7 1.1-9.4 2.9-19.3 5.1-29.4 19.6 4.8 41 8.5 63.5 10.9 13.5 18.5 27.5 35.3 41.6 50-32.6 30.3-63.2 46.9-84 46.9-4.5-.1-8.3-1-11.3-2.7zm237.2-76.2c4.7 38.2-1.1 67.9-14.6 75.8-3 1.8-6.9 2.6-11.5 2.6-20.7 0-51.4-16.5-84-46.6 14-14.7 28-31.4 41.3-49.9 22.6-2.4 44-6.1 63.6-11 2.3 10.1 4.1 19.8 5.2 29.1zm38.5-66.7c-8.6 3.7-18 7-27.7 10.1-5.7-19.6-13.2-40-22.5-60.9 9.2-20.8 16.6-41.1 22.2-60.6 9.9 3.1 19.3 6.5 28.1 10.2 35.4 15.1 58.3 34.9 58.3 50.6-.1 15.7-23 35.6-58.4 50.6zM320.8 78.4z"/>\n' +
	'        <circle cx="420.9" cy="296.5" r="45.7"/>\n' +
	'        <path d="M520.5 78.1z"/>\n' +
	'    </g>\n' +
	'</svg>';

/**
 * Use the native Intl.DateTimeFormat if available, or a polyfill if not.
 */
if (areIntlLocalesSupported(['de'])) {
	DateTimeFormat = global.Intl.DateTimeFormat;
} else {
	const IntlPolyfill = require('intl');
	DateTimeFormat = IntlPolyfill.DateTimeFormat;
	require('intl/locale-data/jsonp/de');
}


const MY_DEFAULT = {
	// URL: 'http://phalcon.local',
	URL: process.env.REACT_APP_API_URL || (PRODUCTION_MODE ? '//api.carperto.de' : '//192.168.11.204'),
	LOADER: svgLoader,
	UPDATE_INTERVAL: 1000 * 60 * 5,
	LONG_UPDATE_INTERVAL: 1000 * 60 * 60 * 24 * 365,
	PRODUCTION: PRODUCTION_MODE,
	DEVELOPMENT: process.env.NODE_ENV === 'development',
	DATE_FORMAT: 'dddd, DD. MMM YYYY',
	FULL_DATE_FORMAT: 'dddd, DD. MMM YYYY - HH:mm'
};

export const DATE_PICKER = (format = MY_DEFAULT.DATE_FORMAT) => ({
	DateTimeFormat: DateTimeFormat,
	locale: i18n.language || 'de',
	cancelLabel: i18n.t('actions.cancel'),
	okLabel: i18n.t('actions.ok'),
	autoOk: true,
	formatDate: date => moment(date).format(format)
});

export const laneAccess = user => user.is_support || ["gp@itholics.de", "mg@itholics.de", "eg@itholics.de", "c.beerden@herbrand.de", "c.beerden@art-mobil.de"].includes(user.email);

export const SHOW_DEV_PRODUCTION = process.env.REACT_APP_SHOW_DEV || false;

export const LANGUAGES = {
	DEFAULT: 'de',
	DEFAULT_INDEX: 0,
	LIST: [
		{
			id: 'de',
			name: 'Deutsch',
			src: german_flag
		},
		{
			id: 'en',
			name: 'English',
			src: usa_flag
		}
	]
};


export const SECTION = {
	MASTER_DATA: 'master-data',
	WORKERS: 'workers',
	APPOINTMENTS: 'appointments',
	CLIENTS: 'clients',
	ORDERS: 'orders',
	RELEASE: 'release',
	STOCK: 'stock',
	ASSISTANCE: 'assistance'
};

export const SECTIONS = [
	{
		id: SECTION.MASTER_DATA,
		translate: 'section.master-data',
		link: '/master-data',
		img: img_options,
		Icon: IconDashBoard
	},
	{
		id: SECTION.WORKERS,
		translate: 'section.workers',
		link: '/workers',
		img: img_workers,
		Icon: IconGroup
	},
	{
		id: SECTION.APPOINTMENTS,
		translate: 'section.appointments',
		link: '/appointments',
		img: img_appointments,
		Icon: IconBuild
	},
	{
		id: SECTION.RELEASE,
		translate: 'section.release',
		link: '/release',
		img: img_release,
		Icon: IconLockOpen
	},
	{
		id: SECTION.CLIENTS,
		translate: 'section.clients',
		link: '/clients',
		img: img_clients,
		Icon: IconContacts
	},
	{
		id: SECTION.ORDERS,
		translate: 'section.orders',
		link: '/orders',
		img: img_orders,
		Icon: IconEvent
	},
	{
		id: SECTION.ASSISTANCE,
		translate: 'section.assistance',
		link: '/assistance',
		img: img_assistant,
		Icon: IconAssignment
	}
];

export const ACCESS_PROP_DEFINTIONS = {
	mayRead: PropTypes.bool,
	mayChange: PropTypes.bool,
	mayCreate: PropTypes.bool,
	mayDelete: PropTypes.bool,
	mayGrant: PropTypes.bool
};

export const accessPropsDefinions = (read = false, change = false, create = false, del = false, grant = false) => ({
	mayRead: read ? PropTypes.bool.isRequired : PropTypes.bool,
	mayChange: change ? PropTypes.bool.isRequired : PropTypes.bool,
	mayCreate: create ? PropTypes.bool.isRequired : PropTypes.bool,
	mayDelete: del ? PropTypes.bool.isRequired : PropTypes.bool,
	mayGrant: grant ? PropTypes.bool.isRequired : PropTypes.bool
});

export const ACCESS_PROP_DEFAULTS = {
	mayRead: false,
	mayChange: false,
	mayCreate: false,
	mayDelete: false,
	mayGrant: false
};

export const SNACKBAR = {
	autoHideDuration: 3000
};

export const DIALOG_ACTION_STYLE = {
	display: 'flex',
	justifyContent: 'space-between',
	padding: '10px 20px'
};


export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL || (PRODUCTION_MODE ? '//api.carperto.de/img/' : '//192.168.11.204/img/');

export const SCREEN = {
	XS: 600,
	SM: 768,
	MD: 992,
	LG: 1200,
	ELG: 1600
};

export const COLOR_SEMANTIC_ERROR = '#9f3a38';


export const MOMENTJS = {
	DATE_FORMAT: 'L'
};

export const PAPER_STYLE = {padding: 20, paddingBottom: 20};

let _salutations = null;
let _salutationList = null;

export const getSalutations = () => {
	if (_salutations) return _salutations;
	const lang = i18n.language.split('-')[0] || "de";
	return _salutations = i18n.getResource(lang, 'translations', 'client.salutations');
};

export const getSalutationList = (index = 'text') => {
	if (_salutationList) return _salutationList;
	const tmp = getSalutations();
	if (tmp) {
		return _salutationList = values(mapValues(tmp, (data, value) => ({[index]: data, value})));
	}
	return [];
};

export const MENU_ANCHOR = (horizontal = 'right', vertical = 'top') => ({
	anchorOrigin: {horizontal, vertical},
	targetOrigin: {horizontal, vertical}
});

export const MENU_ANCHOR_DEFAULT = MENU_ANCHOR();

export const RGBA = (r = 0, g = 0, b = 0, a = 1) => `rgba(${r},${g},${b},${a})`;

export const TIME_MASK = {
	"9": "[0-9]",
	"2": "[0-2]",
	"5": "[0-5]"
};

export const TIME_MASK_PROPS = {
	formatChars: TIME_MASK,
	alwaysShowMask: false,
	maskChar: '_',
	mask: '29:59',
	beforeMaskedValueChange: (n, o, value, m) => {
		if (n && n.selection && n.selection.start === 3 && null !== value && n.value !== o.value) {
			// eslint-disable-next-line
			if (n.value.substr(0, 1) == 2 && value > 3) {
				return o;
			}
		}
		if (null !== value && n && n.selection && n.selection.start === 1 && n.value !== o.value) {
			// eslint-disable-next-line
			if (value == 2 && n.value.substr(1, 1) > 4) {
				n.value = n.value.substr(0, 1) + m.maskChar + n.value.substr(2);
			}
		}
		return n;
	}
};

export const DATE_MASK = {
	"1": "[0-1]",
	"2": "[1-2]",
	"3": "[0-3]",
	"9": "[0-9]",
};

export const DATE_MASK_PROPS = {
	formatChars: DATE_MASK,
	alwaysShowMask: false,
	maskChar: '_',
	mask: '39.19.2999',
	// beforeMaskedValueChange: (n,o,value,m) => {
	// 	if ( n && n.selection && n.selection.start === 3 && null !== value && n.value !== o.value) {
	// 		// eslint-disable-next-line
	// 		if (n.value.substr(0, 1) == 2 && value > 4) {
	// 			return o;
	// 		}
	// 	}
	// 	if (null !== value && n && n.selection && n.selection.start === 1 && n.value !== o.value) {
	// 		// eslint-disable-next-line
	// 		if ( value == 2 && n.value.substr(1,1) > 4 ) {
	// 			n.value = n.value.substr(0,1) + m.maskChar + n.value.substr(2);
	// 		}
	// 	}
	// 	return n;
	// }
};


export const DATE_TIME_MASK = {
	"1": "[0-1]",
	"2": "[1-2]",
	"5": "[0-5]",
	"3": "[0-3]",
	"9": "[0-9]",
};

export const DATE_TIME_MASK_PROPS = {
	formatChars: DATE_TIME_MASK,
	alwaysShowMask: false,
	maskChar: '_',
	mask: '39.19.2999   29:59'
};

export const TIME_REGEXP = {
	F24: /^(2[0-4]|[01]\d|\d):[0-5]\d$/,
	F24_LEADING: /^(2[0-4]|[01]\d):[0-5]\d$/
};

export const SEMANTIC = {
	COLOR_RED: "#9f3a38",
	COLOR_GREEN: "#21ba45",
	COLOR_BLUE: "#2185d0",
	COLOR_ORANGE: "#f2711c",
	COLOR_INVERTED: "#1b1c1d"
};

export const COLORS = {
	PRIMARY: "#61DAFB",
	SECONDARY: "#222222",
	CONTRAST: "#FFFFFF",
	BACKGROUND: "#F3F3F3",
	SEMANTIC_RED: SEMANTIC.COLOR_RED,
	SEMANTIC_GREEN: SEMANTIC.COLOR_GREEN,
	SEMANTIC_BLUE: SEMANTIC.COLOR_BLUE,
	SEMANTIC_ORANGE: SEMANTIC.COLOR_ORANGE,
	SEMANTIC_BROWN: '#90532b',
	SEMANTIC_INVERTED: SEMANTIC.COLOR_INVERTED,
	SEMANTIC_POSITIVE_BACKGROUND: '#fcfff5',
	SEMANTIC_NEGATIVE_BACKGROUND: '#fff6f6',
	SEMANTIC_INFO_BACKGROUND: '#f8ffff',
	SEMANTIC_INFO_COLOR: '#276f86',
	SEMANTIC_WARNING_BACKGROUND: '#fffaf3',
	SEMANTIC_WARNING_COLOR: '#573a08'
};

export const SIGNS = {
	DOTS_VERTICAL: "┋"
};

export default MY_DEFAULT;

export const MODULES = {
	basic: 1,
	payment: 2,
	loancar: 3,
	assist: 4,
	wheel: 5
}